import React, { useState, useContext, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { StoreContext } from '../../components/Store';
import PropTypes from 'prop-types';
import { getTraderDetails, postTraderDetails, putTraderDetails, deleteTrader } from '../../api/settings';
import LoadingSpinner from '../../components/LoadingSpinner';

const paginationModel = { page: 0, pageSize: 50 };

export default function DataTable(props) {
  const [rowData, setRowData] = useState([]);
  const [open, setOpen] = useState(false);
  const [traderData, setTraderData] = useState({});
  const [addTrader, setAddTrader] = useState(false);
  const store = useContext(StoreContext);
  const companyId = props.companyId || store.eoriCompany[0];
  const isReadOnly = store.isReadOnly[0];
  const [loading, setLoading] = useState(true);
  const handleOnChange = (event) => {
    if (event?.$isDayjsObject) {
      setTraderData((prevData) => ({
        ...prevData,
        ['arrivalDate']: new Date(event),
      }));
    } else {
      let title = event.target.name;
      let value = event.target.value;
      setTraderData((prevData) => ({
        ...prevData,
        [title]: value,
      }));
    }
  };

  const apiCall = () => {
    getTraderDetails(companyId || sessionStorage.getItem('companyid'))
      .then((data) => {
        store.traderDetails[1](data);

        for (let i = 0; i < data.length; i++) {
          data[i]['actions'] = 'Edit';
        }
        setRowData(data);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    async function fetchData() {
      try {
        apiCall();
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);
  const handleClose = () => setOpen(false);
  const handleClick = (dataClickedItem) => {
    if (Object.keys(dataClickedItem).length > 0 && dataClickedItem.constructor === Object) {
      let itemsRow = dataClickedItem.row;
      for (const rowItem in itemsRow) {
        setTraderData((prevData) => ({
          ...prevData,
          [rowItem]: itemsRow[rowItem],
        }));
      }
    }
  };
  const handleModalClick = (item) => {
    console.log('clicked modal', item);
    setAddTrader(false);
    setOpen(true);
  };
  const columns = [
    {
      field: 'companyName',
      headerName: 'Name',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
    },
    {
      field: 'EORI',
      headerName: 'EORI',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
    },
    {
      field: 'postCode',
      headerName: 'Postcode',
      type: 'number',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
    },
    {
      field: 'lastModified',
      headerName: 'Last Modified',
      type: 'number',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
      renderCell: (params) => (
        <div>{params.row.lastModified ? new Date(params.row.lastModified).toLocaleDateString('en-GB') : ''}</div>
      ),
    },
    {
      field: 'lastModifiedUser',
      headerName: 'Last Modified User',
      type: 'number',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
    },
    {
      field: 'deleted',
      headerName: 'Status',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
      renderCell: (params) => (params.value === true ? 'Deleted' : 'Active'),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      editable: true,
      headerClassName: 'theme--header',
      renderCell: (params) =>
        !isReadOnly && (
          <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }} onClick={handleModalClick}>
            {params.value}
          </span>
        ),
    },
  ];
  const handleEdit = async () => {
    if (addTrader) {
      const data = {
        Id: traderData.id,
        RefType: traderData.refType,
        CompanyName: traderData.companyName,
        EORI: traderData.EORI,
        StreetAddress: traderData.streetAddress,
        PostalCode: traderData.postCode,
        City: traderData.townCity,
        CountryCode: traderData.Country,
      };
      try {
        postTraderDetails(data);
        setTimeout(apiCall, 1000);
      } catch (e) {
        console.error(e);
      }
    } else {
      const data = {
        Id: traderData.id,
        RefType: traderData.refType,
        CompanyName: traderData.companyName,
        EORI: traderData.EORI,
        StreetAddress: traderData.streetAddress,
        PostalCode: traderData.postCode,
        City: traderData.townCity,
        CountryCode: traderData.Country,
      };
      try {
        putTraderDetails(data, companyId || sessionStorage.getItem('companyid'));
        setTimeout(apiCall, 1000);
      } catch (e) {
        console.error(e);
      }
    }

    setOpen(false);
  };
  const disableTradersData = () => {
    deleteTrader(traderData, companyId || sessionStorage.getItem('companyid'));
    try {
      setTimeout(apiCall, 1000);
    } catch (err) {
      console.log(err);
    }
    setOpen(false);
  };
  return (
    <>
      <div className="hyperlinks">
        <p>
          Each time you add a new Consignor or Consignee to an ENS Declaration, it will be added to your Trader Data for
          future use.
        </p>
        {/* <a onClick={handleModalClickEmpty}>Add a New Trader</a> */}
      </div>
      <Paper sx={{ width: '100%' }}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            {rowData?.length > 0 && (
              <DataGrid
                rows={rowData}
                columns={columns}
                getRowId={() => Math.floor(Math.random() * 100000000)}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[20, 50, 100]}
                sx={{ border: 0 }}
                onRowClick={handleClick}
                onCellDoubleClick={(params, event) => event.stopPropagation()}
              />
            )}
            <Dialog
              open={open}
              onClose={handleClose}
              className="usersTable"
              PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                  event.preventDefault();
                  const formData = new FormData(event.currentTarget);
                  const formJson = Object.fromEntries(formData.entries());
                  const email = formJson.email;
                  console.log(email);
                  handleClose();
                },
              }}
            >
              <DialogTitle>Trader Details</DialogTitle>
              <DialogContent className="edit-add-trader-user">
                <DialogContentText>
                  <Box className="col-wrapper">
                    {/* Label */}
                    <Typography variant="body1" className="typography">
                      Country
                    </Typography>
                    {/* Input Field */}
                    <TextField
                      className="field-component"
                      value={traderData.Country || ''}
                      onChange={handleOnChange}
                      name="Country"
                      inputProps={{
                        maxLength: 2,
                      }}
                    />
                  </Box>
                  <Box className="col-wrapper">
                    {/* Label */}
                    <Typography variant="body1" className="typography">
                      EORI
                    </Typography>
                    {/* Input Field */}
                    <TextField
                      className="field-component"
                      value={traderData.EORI || ''}
                      onChange={handleOnChange}
                      name="EORI"
                    />
                  </Box>

                  <Box className="col-wrapper">
                    {/* Label */}
                    <Typography variant="body1" className="typography">
                      Company Name
                    </Typography>
                    {/* Input Field */}
                    <TextField
                      className="field-component"
                      value={traderData.companyName || ''}
                      onChange={handleOnChange}
                      name="companyName"
                    />
                  </Box>
                  <Box className="col-wrapper">
                    {/* Label */}
                    <Typography variant="body1" className="typography">
                      Street Address
                    </Typography>
                    {/* Input Field */}
                    <TextField
                      className="field-component"
                      value={traderData.streetAddress || ''}
                      onChange={handleOnChange}
                      name="streetAddress"
                    />
                  </Box>
                  <Box className="col-wrapper">
                    {/* Label */}
                    <Typography variant="body1" className="typography">
                      Town / City
                    </Typography>
                    {/* Input Field */}
                    <TextField
                      className="field-component"
                      value={traderData.townCity || ''}
                      onChange={handleOnChange}
                      name="townCity"
                    />
                  </Box>
                  <Box className="col-wrapper">
                    {/* Label */}
                    <Typography variant="body1" className="typography">
                      Postcode
                    </Typography>
                    {/* Input Field */}
                    <TextField
                      className="field-component"
                      value={traderData.postCode || ''}
                      onChange={handleOnChange}
                      name="postCode"
                    />
                  </Box>
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ padding: '24px', justifyContent: 'space-between' }}>
                {!addTrader && (
                  <Button className="button-class deny-button" onClick={disableTradersData}>
                    Delete this Trader Data
                  </Button>
                )}
                <Button onClick={handleEdit} className="button-class">
                  Save and Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Paper>
    </>
  );
}

DataTable.propTypes = {
  companyId: PropTypes.string,
};
